<template>
  <div class="page-wrapper">
    <div class="content container-fluid agent-v2-page waajo-agent-v2">
      <div class="agent-v2-heading">
        <div>
          <h3>Agent AI &amp; Chatbot</h3>
          <p>Kelola cara AI/Chatbot merespons pesan WhatsApp untuk setiap lisensi.</p>
        </div>
        <button type="button" class="btn agent-btn-primary" @click="openCreate">
          <i class="fa fa-plus"></i> Atur Agent
        </button>
      </div>

      <div class="agent-stats">
        <div class="agent-stat">
          <span class="agent-stat-icon is-orange"><i class="fa fa-whatsapp"></i></span>
          <div><strong>{{ licenses.length }}</strong><small>Lisensi</small></div>
        </div>
        <div class="agent-stat">
          <span class="agent-stat-icon is-green"><i class="fa fa-check-circle"></i></span>
          <div><strong>{{ stats.active }}</strong><small>Aktif</small></div>
        </div>
        <div class="agent-stat">
          <span class="agent-stat-icon is-blue"><i class="fa fa-save"></i></span>
          <div><strong>{{ stats.draft }}</strong><small>Draft</small></div>
        </div>
        <button type="button" class="agent-stat is-clickable" @click="showConflicts">
          <span class="agent-stat-icon is-red"><i class="fa fa-exclamation-triangle"></i></span>
          <div><strong>{{ stats.conflict }}</strong><small>Konflik</small></div>
        </button>
      </div>

      <section class="agent-legacy-settings">
        <div class="agent-legacy-head">
          <div>
            <span class="agent-legacy-kicker">Pengaturan Lama</span>
            <h4>Pengaturan Respons Lainnya</h4>
            <p>Menu ini membuka pengaturan respons lama. Tidak mengubah konfigurasi Agent AI &amp; Chatbot V2.</p>
          </div>
        </div>
        <div class="agent-legacy-grid">
          <router-link
            v-for="item in legacySettings"
            :key="item.route"
            :to="item.route"
            class="agent-legacy-card"
          >
            <span class="agent-legacy-icon"><i :class="item.icon"></i></span>
            <span class="agent-legacy-copy">
              <strong>{{ item.label }}</strong>
              <small>{{ item.description }}</small>
            </span>
            <i class="fa fa-arrow-right agent-legacy-arrow"></i>
          </router-link>
        </div>
      </section>

      <div class="agent-filter-card">
        <div class="agent-filter-field">
          <label>Lisensi</label>
          <select v-model="filters.licenseId" class="form-control">
            <option value="">Semua lisensi</option>
            <option v-for="license in licenses" :key="license.id" :value="license.id">
              {{ license.license_name || "Tanpa nama" }} - {{ license.license_phone_number || "-" }}
            </option>
          </select>
        </div>
        <div class="agent-filter-field">
          <label>Mode Respons</label>
          <select v-model="filters.mode" class="form-control">
            <option value="">Semua mode</option>
            <option value="always">Balas Otomatis 24 Jam</option>
            <option value="schedule">Berdasarkan Jam Kerja</option>
            <option value="none">Belum Diatur</option>
          </select>
        </div>
        <div class="agent-filter-field">
          <label>Status</label>
          <select v-model="filters.status" class="form-control">
            <option value="">Semua status</option>
            <option value="active">Aktif</option>
            <option value="draft">Draft</option>
            <option value="conflict">Konflik</option>
            <option value="unconfigured">Belum Diatur</option>
          </select>
        </div>
        <button type="button" class="btn btn-outline-secondary agent-filter-reset" @click="resetFilters">
          <i class="fa fa-refresh"></i> Reset
        </button>
      </div>

      <div v-if="loading" class="agent-v2-state">
        <i class="fa fa-spinner fa-spin"></i>
        <strong>Memuat daftar agent...</strong>
      </div>

      <div v-else-if="error" class="agent-v2-state is-error">
        <i class="fa fa-exclamation-circle"></i>
        <strong>{{ error }}</strong>
        <button type="button" class="btn btn-outline-primary" @click="loadData(true)">Coba lagi</button>
      </div>

      <div v-else-if="!rows.length" class="agent-v2-state">
        <i class="fa fa-whatsapp"></i>
        <strong>Belum ada lisensi WhatsApp</strong>
        <span>Tambahkan lisensi terlebih dahulu sebelum mengatur agent.</span>
      </div>

      <div v-else-if="!filteredRows.length" class="agent-v2-state">
        <i class="fa fa-filter"></i>
        <strong>Tidak ada agent yang cocok</strong>
        <span>Tidak ada agent yang cocok dengan pilihan filter Anda.</span>
      </div>

      <template v-else>
        <div class="agent-table-card">
          <div class="agent-table-wrap">
            <table class="agent-table">
              <thead>
                <tr>
                  <th>Lisensi WhatsApp</th>
                  <th>Mode Respons</th>
                  <th>Jenis Agent</th>
                  <th>Mode AI</th>
                  <th>Status</th>
                  <th class="text-right">Aksi</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="row in filteredRows" :key="row.license.id">
                  <td>
                    <div class="agent-license-cell">
                      <span class="agent-license-avatar"><i class="fa fa-whatsapp"></i></span>
                      <div>
                        <strong>{{ row.license.license_name || "Tanpa nama" }}</strong>
                        <small>{{ row.license.license_phone_number || "-" }}</small>
                        <small v-if="row.latestUpdate" class="agent-muted">Diperbarui {{ row.latestUpdate }}</small>
                      </div>
                    </div>
                  </td>
                  <td>
                    <span class="agent-mode-pill" :class="'is-' + row.modeClass">
                      {{ row.modeLabel }}
                    </span>
                    <button
                      v-if="row.analysis.hasConflict"
                      type="button"
                      class="agent-conflict-link"
                      @click="openConflict(row)"
                    >
                      Pengaturan bertabrakan. Lihat detail.
                    </button>
                  </td>
                  <td>
                    <span class="agent-agent-type">{{ row.agentType }}</span>
                  </td>
                  <td>{{ row.aiMode }}</td>
                  <td>
                    <button
                      v-if="row.status === 'conflict'"
                      type="button"
                      class="agent-status-pill is-conflict agent-status-button"
                      @click="openConflict(row)"
                    >
                      Konflik
                    </button>
                    <span v-else class="agent-status-pill" :class="'is-' + row.status">
                      {{ row.statusLabel }}
                    </span>
                  </td>
                  <td class="text-right">
                    <div class="agent-row-actions">
                      <button
                        v-if="row.status === 'unconfigured'"
                        type="button"
                        class="btn agent-btn-primary btn-sm"
                        @click="openWizard(row, false)"
                      >
                        Atur
                      </button>
                      <button
                        v-else
                        type="button"
                        class="btn btn-outline-secondary btn-sm"
                        @click="openWizard(row, true)"
                      >
                        Edit
                      </button>
                      <button
                        v-if="row.configs.length"
                        type="button"
                        class="btn btn-outline-primary btn-sm"
                        @click="openSimulation(row)"
                      >
                        <i class="fa fa-flask"></i> Simulasikan
                      </button>
                      <button
                        v-if="row.canActivate"
                        type="button"
                        class="btn btn-success btn-sm"
                        :disabled="actionLoading === row.license.id"
                        @click="activateRow(row)"
                      >
                        Aktifkan
                      </button>
                      <button
                        v-if="row.canDeactivate"
                        type="button"
                        class="btn btn-outline-warning btn-sm"
                        :disabled="actionLoading === row.license.id"
                        @click="deactivateRow(row)"
                      >
                        Nonaktifkan
                      </button>
                      <div v-if="row.configs.length" class="dropdown d-inline-block">
                        <button
                          type="button"
                          class="btn btn-outline-secondary btn-sm dropdown-toggle"
                          data-toggle="dropdown"
                          aria-haspopup="true"
                          aria-expanded="false"
                          title="Aksi lainnya"
                        >
                          <i class="fa fa-ellipsis-h"></i>
                        </button>
                        <div class="dropdown-menu dropdown-menu-right">
                          <button
                            type="button"
                            class="dropdown-item"
                            data-toggle="modal"
                            data-target="#agent_configs_modal"
                            @click="openConfigs(row)"
                          >
                            <i class="fa fa-list"></i> Lihat pengaturan
                          </button>
                          <button type="button" class="dropdown-item" @click="openKb(row.license)">
                            <i class="fa fa-book"></i> Kelola Knowledge Base
                          </button>
                        </div>
                      </div>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <!-- Mobile cards -->
          <div class="agent-mobile-list">
            <article v-for="row in filteredRows" :key="'mobile-' + row.license.id" class="agent-mobile-card">
              <div class="agent-mobile-head">
                <div>
                  <strong>{{ row.license.license_name || "Tanpa nama" }}</strong>
                  <small>{{ row.license.license_phone_number || "-" }}</small>
                </div>
                <button
                  v-if="row.status === 'conflict'"
                  type="button"
                  class="agent-status-pill is-conflict agent-status-button"
                  @click="openConflict(row)"
                >
                  Konflik
                </button>
                <span v-else class="agent-status-pill" :class="'is-' + row.status">{{ row.statusLabel }}</span>
              </div>
              <button
                v-if="row.analysis.hasConflict"
                type="button"
                class="agent-conflict-link"
                @click="openConflict(row)"
              >
                Pengaturan bertabrakan. Lihat detail.
              </button>
              <div class="agent-mobile-meta">
                <div><span>Mode</span><strong>{{ row.modeLabel }}</strong></div>
                <div><span>Agent</span><strong>{{ row.agentType }}</strong></div>
                <div><span>Mode AI</span><strong>{{ row.aiMode }}</strong></div>
              </div>
              <div class="agent-mobile-actions">
                <button v-if="row.status === 'unconfigured'" type="button" class="btn agent-btn-primary" @click="openWizard(row, false)">Atur</button>
                <button v-else type="button" class="btn btn-outline-secondary" @click="openWizard(row, true)">Edit</button>
                <button v-if="row.configs.length" type="button" class="btn btn-outline-primary" @click="openSimulation(row)">Simulasikan</button>
                <button v-if="row.canActivate" type="button" class="btn btn-success" @click="activateRow(row)">Aktifkan</button>
                <button v-if="row.canDeactivate" type="button" class="btn btn-outline-warning" @click="deactivateRow(row)">Nonaktifkan</button>
              </div>
            </article>
          </div>
        </div>
      </template>

      <div class="modal fade" id="agent_configs_modal" tabindex="-1" role="dialog" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">Pengaturan {{ selectedRow ? selectedRow.license.license_name : "" }}</h5>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <div v-if="selectedRow && selectedRow.analysis.hasConflict" class="agent-alert is-warning">
                <i class="fa fa-exclamation-triangle"></i>
                <div>
                  <strong>Pengaturan bertabrakan</strong>
                  <div v-for="(message, index) in selectedRow.analysis.messages" :key="index">{{ message }}</div>
                </div>
              </div>
              <div v-if="selectedRow && selectedRow.configs.length" class="agent-config-list">
                <div v-for="config in selectedRow.configs" :key="config.id" class="agent-config-list-row">
                  <div>
                    <span class="agent-mode-pill" :class="'is-' + modeClass(modeFromConfig(config))">
                      {{ modeLabel(modeFromConfig(config)) }}
                    </span>
                    <strong>{{ config.title || "Tanpa judul" }}</strong>
                    <small>{{ agentLabel(config) }} · {{ Number(config.is_publish) === 1 ? "Aktif" : "Draft" }}</small>
                  </div>
                  <div class="agent-config-list-actions">
                    <button
                      type="button"
                      class="btn btn-outline-primary btn-sm"
                      @click="openSimulation(selectedRow, config)"
                    >
                      <i class="fa fa-flask"></i> Simulasikan
                    </button>
                    <button
                      type="button"
                      class="btn btn-outline-danger btn-sm"
                      :disabled="deletingId === config.id"
                      @click="deleteConfig(config)"
                    >
                      <i class="fa fa-trash-o"></i> Hapus
                    </button>
                  </div>
                </div>
              </div>
              <div v-else class="agent-v2-state">
                <strong>Belum ada pengaturan.</strong>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div v-if="conflictRow" class="agent-modal-backdrop" @click.self="closeConflict">
        <div class="agent-modal agent-conflict-modal" role="dialog" aria-modal="true" aria-labelledby="agentConflictTitle">
          <div class="agent-modal-head">
            <div>
              <span class="agent-modal-kicker">Konflik</span>
              <h5 id="agentConflictTitle">Detail Konflik Pengaturan</h5>
              <p class="agent-modal-subtitle">
                {{ conflictRow.license.license_name || "Tanpa nama" }} · {{ conflictRow.license.license_phone_number || "-" }}
              </p>
            </div>
            <button type="button" class="agent-modal-close" aria-label="Tutup" @click="closeConflict">
              <i class="fa fa-times"></i>
            </button>
          </div>

          <div class="agent-modal-body">
            <div v-if="conflictActionError" class="agent-alert is-danger">
              <i class="fa fa-exclamation-circle"></i>
              <span>{{ conflictActionError }}</span>
              <button type="button" class="btn btn-sm btn-outline-danger agent-alert-retry" @click="refreshConflict">
                Muat ulang
              </button>
            </div>

            <div v-if="!conflictRow.analysis.details.length" class="agent-v2-state">
              <strong>Detail konflik belum tersedia.</strong>
              <span>Muat ulang data agent untuk melihat detail terbaru.</span>
              <button type="button" class="btn btn-outline-primary" @click="refreshConflict">Coba lagi</button>
            </div>

            <div
              v-for="conflict in conflictRow.analysis.details"
              :key="conflict.key"
              class="agent-conflict-block"
            >
              <div class="agent-conflict-block-head">
                <div>
                  <h6>{{ conflict.title }}</h6>
                  <span>{{ conflict.modeLabel }} · {{ conflict.count }} pengaturan terlibat</span>
                </div>
              </div>
              <p class="agent-conflict-reason">{{ conflict.reason }}</p>

              <div class="agent-conflict-config-list">
                <div v-for="config in conflict.configs" :key="config.id" class="agent-conflict-config">
                  <div class="agent-conflict-config-main">
                    <span class="agent-mode-pill" :class="'is-' + modeClass(modeFromConfig(config))">
                      {{ modeLabel(modeFromConfig(config)) }}
                    </span>
                    <strong>{{ config.title || "Pengaturan tanpa judul" }}</strong>
                    <span class="agent-status-pill" :class="Number(config.is_publish) === 1 ? 'is-active' : 'is-draft'">
                      {{ Number(config.is_publish) === 1 ? "Aktif" : "Draft" }}
                    </span>
                  </div>
                  <div class="agent-conflict-config-actions">
                    <button type="button" class="btn btn-outline-secondary btn-sm" @click="editConflictConfig(config)">
                      Buka pengaturan
                    </button>
                    <button
                      v-if="Number(config.is_publish) === 1"
                      type="button"
                      class="btn btn-outline-warning btn-sm"
                      :disabled="conflictActionId === config.id"
                      @click="deactivateConflictConfig(config)"
                    >
                      Nonaktifkan
                    </button>
                    <button
                      type="button"
                      class="btn btn-outline-danger btn-sm"
                      :disabled="deletingId === config.id"
                      @click="deleteConflictConfig(config)"
                    >
                      Hapus
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="agent-modal-foot">
            <button type="button" class="btn btn-outline-secondary" @click="closeConflict">Tutup</button>
          </div>
        </div>
      </div>

      <div v-if="confirmOpen" class="agent-confirm-backdrop" @click.self="cancelConfirm">
        <div
          ref="confirmDialog"
          class="agent-confirm"
          role="alertdialog"
          aria-modal="true"
          aria-labelledby="agentConfirmTitle"
          tabindex="-1"
          @keydown.esc="cancelConfirm"
        >
          <div class="agent-confirm-head">
            <h5 id="agentConfirmTitle">
              {{ confirmType === "delete" ? "Hapus pengaturan?" : "Nonaktifkan pengaturan?" }}
            </h5>
          </div>
          <div class="agent-confirm-body">
            <p v-if="confirmTarget">
              <template v-if="confirmType === 'delete'">
                Pengaturan <strong>{{ confirmTarget.title || "ini" }}</strong>
                <span class="agent-confirm-meta">({{ modeLabel(modeFromConfig(confirmTarget)) }})</span>
                akan dihapus. Tindakan ini tidak dapat dibatalkan.
              </template>
              <template v-else>
                Pengaturan <strong>{{ confirmTarget.title || "ini" }}</strong>
                <span class="agent-confirm-meta">({{ modeLabel(modeFromConfig(confirmTarget)) }})</span>
                akan berhenti merespons sampai diaktifkan kembali.
              </template>
            </p>
            <p
              v-if="confirmType === 'delete' && confirmTarget && Number(confirmTarget.is_publish) === 1"
              class="agent-confirm-warning"
            >
              Pengaturan ini sedang aktif dan akan berhenti merespons.
            </p>
            <div v-if="confirmError" class="agent-alert is-danger">
              <i class="fa fa-exclamation-circle"></i>
              <span>{{ confirmError }}</span>
            </div>
          </div>
          <div class="agent-confirm-foot">
            <button type="button" class="btn btn-outline-secondary" :disabled="confirmLoading" @click="cancelConfirm">
              Batal
            </button>
            <button
              type="button"
              class="btn"
              :class="confirmType === 'delete' ? 'btn-danger' : 'btn-warning'"
              :disabled="confirmLoading"
              @click="submitConfirm"
            >
              <i v-if="confirmLoading" class="fa fa-spinner fa-spin"></i>
              <template v-if="confirmLoading">
                {{ confirmType === "delete" ? "Menghapus..." : "Menonaktifkan..." }}
              </template>
              <template v-else>
                {{ confirmType === "delete" ? "Ya, hapus" : "Ya, nonaktifkan" }}
              </template>
            </button>
          </div>
        </div>
      </div>

      <knowledge-base-modal
        :show="kbModalOpen"
        :license="kbLicense"
        :limit="5"
        @close="closeKb"
        @changed="onKbChanged"
      />
    </div>
  </div>
</template>

<script>
import KnowledgeBaseModal from "./components/KnowledgeBaseModal.vue";
import {
  MODE_ALWAYS,
  MODE_WORKING,
  MODE_AWAY,
  modeFromConfig,
  modeLabel,
  licenseConfigs,
  analyzeConfigs,
  licenseMode,
  aggregateAgentType,
  aggregateAiMode,
  licenseStatus,
  isActive,
  activationIds,
  friendlyError,
  isConflictError
} from "./utils";

export default {
  name: "AgentAiV2List",
  components: {
    KnowledgeBaseModal
  },
  data() {
    return {
      loading: false,
      error: "",
      actionLoading: "",
      deletingId: "",
      licenses: [],
      configs: [],
      filters: {
        licenseId: "",
        mode: "",
        status: ""
      },
      legacySettings: [
        {
          label: "Balas Otomatis",
          route: "/automation/welcome-chat/list",
          description: "Pengaturan respons otomatis sepanjang hari.",
          icon: "fa fa-refresh"
        },
        {
          label: "Balas di Jam Kerja",
          route: "/automation/working-chat/list",
          description: "Pengaturan respons selama jam kerja.",
          icon: "fa fa-clock-o"
        },
        {
          label: "Balas di Luar Jam Kerja",
          route: "/automation/away-chat/list",
          description: "Pengaturan respons di luar jam kerja.",
          icon: "fa fa-moon-o"
        }
      ],
      selectedRow: null,
      conflictRow: null,
      conflictActionId: "",
      conflictActionError: "",
      kbModalOpen: false,
      kbLicense: null,
      confirmOpen: false,
      confirmType: "",
      confirmTarget: null,
      confirmSource: "",
      confirmLoading: false,
      confirmError: "",
      conflictQueryHandled: false,
      loadPromise: null,
      loadSeq: 0,
      needsRefresh: false
    };
  },
  computed: {
    rows() {
      return this.licenses.map(license => {
        const configs = licenseConfigs(this.configs, license.id);
        const analysis = analyzeConfigs(configs);
        const mode = licenseMode(configs);
        const status = licenseStatus(configs, analysis);
        const activeIds = configs.filter(isActive).map(item => item.id);
        const modeForActivation = mode === MODE_ALWAYS ? MODE_ALWAYS : "schedule";
        const ids = activationIds(configs, modeForActivation);
        const latest = configs.reduce((value, item) => {
          const time = Number(item.update_datetime || item.create_datetime || 0);
          return time > value ? time : value;
        }, 0);
        return {
          license,
          configs,
          analysis,
          mode,
          modeClass: mode === MODE_ALWAYS ? "always" : (mode === "schedule" ? "schedule" : "none"),
          modeLabel: mode === MODE_ALWAYS ? "Balas Otomatis 24 Jam" : (mode === "schedule" ? "Berdasarkan Jam Kerja" : "Belum Diatur"),
          agentType: aggregateAgentType(configs),
          aiMode: aggregateAiMode(configs),
          status,
          statusLabel: {
            active: "Aktif",
            draft: "Draft",
            conflict: "Konflik",
            unconfigured: "Belum Diatur"
          }[status],
          activeIds,
          activationIds: ids,
          canActivate: ids.length > 0 && !analysis.hasConflict && configs.some(item => !isActive(item)),
          canDeactivate: activeIds.length > 0,
          latestUpdate: latest ? this.formatUnix(latest) : ""
        };
      });
    },
    filteredRows() {
      return this.rows.filter(row => {
        if (this.filters.licenseId && row.license.id !== this.filters.licenseId) return false;
        if (this.filters.mode && row.modeClass !== this.filters.mode && this.filters.mode !== "none") return false;
        if (this.filters.mode === "none" && row.modeClass !== "none") return false;
        if (this.filters.status && row.status !== this.filters.status) return false;
        return true;
      });
    },
    stats() {
      return {
        active: this.rows.filter(row => row.status === "active").length,
        draft: this.rows.filter(row => row.status === "draft").length,
        conflict: this.rows.filter(row => row.status === "conflict").length
      };
    }
  },
  created() {
    this.loadData().then(() => {
      this.openConflictFromQuery();
    });
  },
  deactivated() {
    // Layout Agent V2 memakai keep-alive. Tandai bahwa data perlu dimuat
    // ulang saat pengguna kembali ke daftar (mis. setelah simpan di wizard).
    this.needsRefresh = true;
  },
  activated() {
    if (!this.needsRefresh) return;
    this.needsRefresh = false;
    this.loadData(true);
  },
  methods: {
    modeFromConfig,
    modeLabel,
    modeClass(mode) {
      if (mode === MODE_ALWAYS) return "always";
      if (mode === MODE_WORKING) return "working";
      if (mode === MODE_AWAY) return "away";
      return "none";
    },
    agentLabel(config) {
      if (!config) return "-";
      const type = Number(config.ai_status) === 1 ? "Chat AI" : "Chatbot";
      if (Number(config.ai_status) !== 1) return type;
      return type + " / " + (config.ai_type === "summarize" ? "Knowledge Base" : "Chat Completions");
    },
    formatUnix(value) {
      const date = new Date(Number(value) * 1000);
      if (isNaN(date.getTime())) return "";
      return date.toLocaleDateString("id-ID", { day: "2-digit", month: "short", year: "numeric" });
    },
    async loadData(force) {
      if (this.loadPromise && !force) return this.loadPromise;

      const seq = ++this.loadSeq;
      this.loading = true;
      this.error = "";

      const request = Promise.all([this.fetchLicenses(), this.fetchConfigs()])
        .then(([licenses, configs]) => {
          if (seq !== this.loadSeq) return;
          this.licenses = licenses;
          this.configs = configs;
        })
        .catch(error => {
          if (seq !== this.loadSeq) return;
          this.error = friendlyError(
            error,
            "Daftar agent belum berhasil dimuat. Silakan coba lagi."
          );
        })
        .finally(() => {
          if (this.loadPromise === request) this.loadPromise = null;
          if (seq === this.loadSeq) this.loading = false;
        });

      this.loadPromise = request;
      return request;
    },
    openConflictFromQuery() {
      if (this.conflictQueryHandled) return;
      const query = this.$route.query || {};
      if (query.conflict !== "1") return;
      this.conflictQueryHandled = true;
      this.filters.status = "conflict";
      const licenseId = query.license_id || "";
      const row =
        this.rows.find(item => item.license.id === licenseId && item.analysis.hasConflict) ||
        this.rows.find(item => item.analysis.hasConflict);
      if (row) this.openConflict(row);
    },
    async fetchLicenses() {
      const response = await this.$store.dispatch("license/getLicenseList", {
        license_name: "",
        license_phone_number: "",
        license_status: "",
        page: 0,
        perPage: 200
      });
      return (response.data && response.data.data) || [];
    },
    async fetchConfigs() {
      const response = await this.$store.dispatch("automation/listSmartReply", {
        columnFilters: {
          license_id: "",
          title: "",
          message: "",
          trigger_on: "",
          is_working_or_away: "",
          is_working: ""
        },
        page: 0,
        perPage: 500
      });
      return ((response.data && response.data.data) || []).filter(
        row => row.trigger_on === "all"
      );
    },
    resetFilters() {
      this.filters = { licenseId: "", mode: "", status: "" };
    },
    showConflicts() {
      this.filters.status = "conflict";
      const first = this.rows.find(row => row.status === "conflict");
      if (first) this.openConflict(first);
    },
    openConflict(row) {
      this.conflictActionError = "";
      this.conflictRow = row;
    },
    closeConflict() {
      this.conflictRow = null;
      this.conflictActionError = "";
    },
    async refreshConflict() {
      const licenseId = this.conflictRow ? this.conflictRow.license.id : "";
      await this.loadData(true);
      if (this.error) {
        this.conflictActionError =
          "Daftar agent belum berhasil diperbarui. Silakan coba lagi.";
        return;
      }
      this.conflictRow = licenseId ? this.rows.find(row => row.license.id === licenseId) || null : null;
      this.conflictActionError = "";
    },
    editConflictConfig(config) {
      if (!this.conflictRow) return;
      const mode = modeFromConfig(config);
      const query = {
        license_id: this.conflictRow.license.id,
        id: config.id,
        mode: mode === MODE_ALWAYS ? "always" : "schedule"
      };
      this.closeConflict();
      this.$router.push({ path: "/agent-ai-v2/edit", query: query });
    },
    deactivateConflictConfig(config) {
      this.openConfirm("deactivate", config, "conflict");
    },
    deleteConflictConfig(config) {
      this.openConfirm("delete", config, "conflict");
    },
    openKb(license) {
      this.kbLicense = license;
      this.kbModalOpen = true;
    },
    closeKb() {
      this.kbModalOpen = false;
    },
    onKbChanged() {
      // Jumlah KB ditampilkan di modal; daftar agent tidak berubah.
    },
    openCreate() {
      this.$router.push({ path: "/agent-ai-v2/create" });
    },
    openWizard(row, edit) {
      const query = { license_id: row.license.id };
      if (edit && row.mode === MODE_ALWAYS) {
        const config = row.configs.find(item => modeFromConfig(item) === MODE_ALWAYS);
        if (config) query.id = config.id;
        query.mode = "always";
      } else if (edit && row.mode === "schedule") {
        query.mode = "schedule";
        const preferred = row.configs.find(item => modeFromConfig(item) === MODE_WORKING);
        if (preferred) query.id = preferred.id;
      }
      this.$router.push({ path: edit ? "/agent-ai-v2/edit" : "/agent-ai-v2/create", query: query });
    },
    openSimulation(row, config) {
      if (!row || !row.license) return;
      const query = { license_id: row.license.id };
      if (config && config.id) {
        query.config_id = config.id;
      } else if (row.configs && row.configs.length === 1) {
        query.config_id = row.configs[0].id;
      }
      this.$router.push({ path: "/agent-ai-v2/simulation", query: query });
    },
    async activateRow(row) {
      if (!row.canActivate || this.actionLoading) return;
      const confirmed = await this.$fire({
        title: "Aktifkan agent?",
        text: "Agent akan mulai merespons pesan sesuai mode yang dipilih. Pengaturan lain yang bertabrakan tidak akan dinonaktifkan otomatis.",
        type: "question",
        showCancelButton: true,
        confirmButtonText: "Ya, aktifkan",
        cancelButtonText: "Batal"
      });
      if (!confirmed.value) return;
      this.actionLoading = row.license.id;
      try {
        await this.$store.dispatch("automation/activateAgentV2", {
          license_id: row.license.id,
          ids: row.activationIds
        });
        await this.loadData(true);
        if (this.error) {
          this.$fire({
            title: "Agent berhasil diaktifkan, tetapi daftar belum diperbarui",
            text: this.error,
            type: "warning"
          });
        } else {
          this.$fire({ title: "Berhasil", text: "Agent berhasil diaktifkan.", type: "success", timer: 1800 });
        }
      } catch (error) {
        if (isConflictError(error)) {
          this.openConflict(row);
        } else {
          this.$fire({
            title: "Agent belum dapat diaktifkan",
            text: friendlyError(error, "Agent belum berhasil diaktifkan. Silakan coba lagi."),
            type: "error"
          });
        }
      } finally {
        this.actionLoading = "";
      }
    },
    async deactivateRow(row) {
      if (!row.canDeactivate || this.actionLoading) return;
      const confirmed = await this.$fire({
        title: "Nonaktifkan agent?",
        text: "Agent akan berhenti merespons sampai diaktifkan kembali.",
        type: "warning",
        showCancelButton: true,
        confirmButtonText: "Ya, nonaktifkan",
        cancelButtonText: "Batal"
      });
      if (!confirmed.value) return;
      this.actionLoading = row.license.id;
      try {
        await this.$store.dispatch("automation/deactivateAgentV2", {
          license_id: row.license.id,
          ids: row.activeIds
        });
        await this.loadData(true);
        if (this.error) {
          this.$fire({
            title: "Agent berhasil dinonaktifkan, tetapi daftar belum diperbarui",
            text: this.error,
            type: "warning"
          });
        } else {
          this.$fire({ title: "Berhasil", text: "Agent berhasil dinonaktifkan.", type: "success", timer: 1800 });
        }
      } catch (error) {
        this.$fire({
          title: "Agent belum berhasil dinonaktifkan",
          text: friendlyError(error, "Agent belum berhasil dinonaktifkan. Silakan coba lagi."),
          type: "error"
        });
      } finally {
        this.actionLoading = "";
      }
    },
    openConfigs(row) {
      this.selectedRow = row;
    },
    deleteConfig(config) {
      this.openConfirm("delete", config, "config");
    },
    openConfirm(type, target, source) {
      if (!target || this.confirmLoading) return;
      if (source === "conflict" && !this.conflictRow) return;
      if (source === "config" && !this.selectedRow) return;
      this.confirmType = type;
      this.confirmTarget = target;
      this.confirmSource = source;
      this.confirmError = "";
      this.confirmOpen = true;
      this.$nextTick(() => {
        const dialog = this.$refs.confirmDialog;
        if (dialog && dialog.focus) dialog.focus();
      });
    },
    cancelConfirm() {
      if (this.confirmLoading) return;
      this.closeConfirm();
    },
    closeConfirm() {
      this.confirmOpen = false;
      this.confirmType = "";
      this.confirmTarget = null;
      this.confirmSource = "";
      this.confirmError = "";
    },
    async submitConfirm() {
      if (!this.confirmTarget || this.confirmLoading) return;
      const target = this.confirmTarget;
      const type = this.confirmType;
      const source = this.confirmSource;
      const isDelete = type === "delete";
      const sourceLicenseId =
        source === "conflict"
          ? this.conflictRow && this.conflictRow.license.id
          : this.selectedRow && this.selectedRow.license.id;
      if (!sourceLicenseId) {
        this.confirmError = "Lisensi tidak ditemukan. Tutup dialog lalu coba lagi.";
        return;
      }

      this.confirmLoading = true;
      this.confirmError = "";
      if (source === "conflict") {
        this.conflictActionError = "";
      }
      if (isDelete) {
        this.deletingId = target.id;
      } else {
        this.conflictActionId = target.id;
      }

      try {
        if (isDelete) {
          // Endpoint lama sudah dipakai halaman lama dan memvalidasi ownership
          // berdasarkan token. Payload hanya membutuhkan id konfigurasi.
          await this.$store.dispatch("automation/deleteSmartReplySilent", { id: target.id });
        } else {
          await this.$store.dispatch("automation/deactivateAgentV2", {
            license_id: sourceLicenseId,
            ids: [target.id]
          });
        }
      } catch (error) {
        this.confirmError = friendlyError(
          error,
          isDelete
            ? "Pengaturan belum berhasil dihapus. Silakan coba lagi."
            : "Pengaturan belum berhasil dinonaktifkan. Silakan coba lagi."
        );
        this.confirmLoading = false;
        if (isDelete) {
          this.deletingId = "";
        } else {
          this.conflictActionId = "";
        }
        return;
      }

      // Aksi sudah dikonfirmasi server. Tutup dialog konfirmasi sebelum memuat
      // ulang data agar tidak ada backdrop yang tertinggal.
      this.closeConfirm();
      this.confirmLoading = false;

      const verb = isDelete ? "dihapus" : "dinonaktifkan";
      let refreshOk = true;
      let actionVerified = true;
      try {
        await this.loadData(true);
        if (this.error) throw new Error(this.error);
        const refreshed = this.rows.find(row => row.license.id === sourceLicenseId) || null;
        const targetStillExists = this.configs.some(item => String(item.id) === String(target.id));
        const targetStillActive = isDelete
          ? false
          : this.configs.some(
              item => String(item.id) === String(target.id) && Number(item.is_publish) === 1
            );

        if ((isDelete && targetStillExists) || (!isDelete && targetStillActive)) {
          actionVerified = false;
          const message = isDelete
            ? "Pengaturan belum berhasil dihapus. Silakan coba lagi."
            : "Pengaturan belum berhasil dinonaktifkan. Silakan coba lagi.";
          if (source === "conflict") {
            this.conflictRow = refreshed && refreshed.analysis.hasConflict ? refreshed : null;
            this.conflictActionError = message;
          } else {
            this.selectedRow = refreshed;
            this.$fire({
              title: isDelete ? "Pengaturan belum berhasil dihapus" : "Pengaturan belum berhasil dinonaktifkan",
              text: message,
              type: "error"
            });
          }
        } else if (source === "conflict") {
          this.conflictRow = refreshed && refreshed.analysis.hasConflict ? refreshed : null;
          if (!this.conflictRow) {
            this.closeConflict();
          }
        } else {
          this.selectedRow = refreshed;
          if ((!this.selectedRow || !this.selectedRow.configs.length) && window.$) {
            window.$("#agent_configs_modal").modal("hide");
          }
        }
      } catch (refreshError) {
        refreshOk = false;
        const message = "Pengaturan berhasil " + verb + ", tetapi daftar belum dapat diperbarui. Muat ulang halaman atau coba lagi.";
        if (source === "conflict") {
          this.conflictActionError = message;
        }
      } finally {
        this.deletingId = "";
        this.conflictActionId = "";
      }

      if (!actionVerified) return;

      const result = {
        title: "Berhasil",
        text: refreshOk
          ? "Pengaturan berhasil " + verb + "."
          : "Pengaturan berhasil " + verb + ", tetapi daftar belum dapat diperbarui. Muat ulang halaman.",
        type: refreshOk ? "success" : "warning"
      };
      if (refreshOk) result.timer = 1800;
      this.$fire(result);
    }
  }
};
</script>

<style scoped>
.agent-v2-page {
  color: #344054;
  padding-bottom: 72px;
}
.agent-v2-heading {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 16px;
}
.agent-v2-heading h3 {
  margin: 0 0 4px;
  color: #172033;
  font-size: 26px;
  font-weight: 800;
}
.agent-v2-heading p {
  margin: 0;
  color: #7b8ba3;
  font-size: 13px;
}
.agent-btn-primary {
  border: 0;
  background: #fe9b44;
  color: #fff;
  font-weight: 800;
}
.agent-btn-primary:hover,
.agent-btn-primary:focus {
  background: #e77f25;
  color: #fff;
}
.agent-stats {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 10px;
  margin-bottom: 14px;
}
.agent-stat {
  display: flex;
  align-items: center;
  gap: 10px;
  border: 1px solid #e7eaf0;
  border-radius: 12px;
  background: #fff;
  padding: 11px 12px;
  text-align: left;
}
.agent-stat.is-clickable {
  cursor: pointer;
}
.agent-stat.is-clickable:hover {
  border-color: #f7c99f;
}
.agent-stat-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 34px;
  height: 34px;
  border-radius: 10px;
  font-size: 15px;
}
.agent-stat-icon.is-orange {
  background: #fff4e8;
  color: #e77f25;
}
.agent-stat-icon.is-green {
  background: #e7f8ef;
  color: #0b8f4d;
}
.agent-stat-icon.is-blue {
  background: #e8f2ff;
  color: #1769d1;
}
.agent-stat-icon.is-red {
  background: #fff0f0;
  color: #c02626;
}
.agent-stat strong {
  display: block;
  color: #172033;
  font-size: 20px;
  line-height: 1.1;
}
.agent-stat small {
  display: block;
  color: #98a2b3;
  font-size: 12px;
  font-weight: 700;
  text-transform: uppercase;
}
.agent-legacy-settings {
  margin-bottom: 14px;
  border: 1px solid #edf1f6;
  border-radius: 12px;
  background: #fbfcfe;
  padding: 12px;
}
.agent-legacy-head {
  margin-bottom: 9px;
}
.agent-legacy-kicker {
  display: block;
  color: #b45309;
  font-size: 12px;
  font-weight: 800;
  letter-spacing: .08em;
  text-transform: uppercase;
}
.agent-legacy-head h4 {
  margin: 3px 0 2px;
  color: #344054;
  font-size: 13px;
  font-weight: 800;
}
.agent-legacy-head p {
  margin: 0;
  color: #7b8ba3;
  font-size: 12px;
  line-height: 1.45;
}
.agent-legacy-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
  gap: 8px;
}
.agent-legacy-card {
  display: flex;
  align-items: center;
  gap: 9px;
  min-width: 0;
  border: 1px solid #e7eaf0;
  border-radius: 10px;
  background: #fff;
  color: #344054;
  padding: 9px 10px;
  text-decoration: none;
  transition: border-color .15s ease, background-color .15s ease;
}
.agent-legacy-card:hover {
  border-color: #f7c98b;
  background: #fffaf3;
  color: #344054;
  text-decoration: none;
}
.agent-legacy-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 30px;
  width: 30px;
  height: 30px;
  border-radius: 8px;
  background: #fff3e3;
  color: #e77f25;
  font-size: 13px;
}
.agent-legacy-copy {
  flex: 1 1 auto;
  min-width: 0;
}
.agent-legacy-copy strong {
  display: block;
  color: #344054;
  font-size: 12px;
  font-weight: 800;
}
.agent-legacy-copy small {
  display: block;
  margin-top: 1px;
  color: #7b8ba3;
  font-size: 12px;
  line-height: 1.35;
}
.agent-legacy-arrow {
  flex: 0 0 auto;
  color: #98a2b3;
  font-size: 12px;
}
.agent-filter-card {
  display: grid;
  grid-template-columns: 1.4fr 1fr 1fr auto;
  gap: 10px;
  align-items: end;
  border: 1px solid #e7eaf0;
  border-radius: 13px;
  background: #fff;
  padding: 12px;
  margin-bottom: 14px;
}
.agent-filter-field label {
  display: block;
  margin-bottom: 4px;
  color: #7b8ba3;
  font-size: 12px;
  font-weight: 800;
  text-transform: uppercase;
}
.agent-filter-field .form-control {
  height: 36px;
  font-size: 12px;
}
.agent-filter-reset {
  height: 36px;
  font-size: 12px;
}
.agent-table-card {
  border: 1px solid #e7eaf0;
  border-radius: 14px;
  background: #fff;
  overflow: hidden;
}
.agent-table-wrap {
  overflow-x: auto;
}
.agent-table {
  width: 100%;
  min-width: 920px;
  border-collapse: collapse;
  font-size: 12px;
}
.agent-table thead th {
  background: #fbfcfe;
  border-bottom: 1px solid #edf1f6;
  color: #7b8ba3;
  font-size: 12px;
  font-weight: 800;
  letter-spacing: .04em;
  text-transform: uppercase;
  padding: 11px 12px;
  white-space: nowrap;
}
.agent-table tbody td {
  border-bottom: 1px solid #f1f4f8;
  padding: 12px;
  color: #475467;
  vertical-align: middle;
}
.agent-table tbody tr:last-child td {
  border-bottom: 0;
}
.agent-license-cell {
  display: flex;
  align-items: flex-start;
  gap: 9px;
  min-width: 0;
}
.agent-license-avatar {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 32px;
  width: 32px;
  height: 32px;
  border-radius: 9px;
  background: #e7f8ef;
  color: #0b8f4d;
  font-size: 15px;
}
.agent-license-cell strong {
  display: block;
  color: #344054;
  font-size: 12px;
  overflow-wrap: anywhere;
}
.agent-license-cell small {
  display: block;
  margin-top: 1px;
  color: #7b8ba3;
  font-size: 12px;
}
.agent-license-cell .agent-muted {
  color: #b0b8c5;
  font-size: 12px;
}
.agent-mode-pill,
.agent-status-pill {
  display: inline-flex;
  align-items: center;
  border-radius: 999px;
  padding: 4px 9px;
  font-size: 12px;
  font-weight: 800;
  white-space: nowrap;
}
.agent-mode-pill.is-always {
  background: #fff1e5;
  color: #e77f25;
}
.agent-mode-pill.is-schedule {
  background: #e8f2ff;
  color: #1769d1;
}
.agent-mode-pill.is-none {
  background: #f2f4f7;
  color: #667085;
}
.agent-mode-pill.is-working {
  background: #e8f2ff;
  color: #1769d1;
}
.agent-mode-pill.is-away {
  background: #f1eaff;
  color: #7f56d9;
}
.agent-status-pill.is-active {
  background: #e7f8ef;
  color: #0b8f4d;
}
.agent-status-pill.is-draft {
  background: #fff4e5;
  color: #b76e00;
}
.agent-status-pill.is-conflict {
  background: #fff0f0;
  color: #c02626;
}
.agent-status-pill.is-unconfigured {
  background: #f2f4f7;
  color: #667085;
}
.agent-status-button {
  border: 0;
  cursor: pointer;
}
.agent-status-button:hover {
  text-decoration: underline;
}
.agent-conflict-link {
  display: block;
  margin-top: 5px;
  border: 0;
  background: transparent;
  color: #b76e00;
  padding: 0;
  font-size: 12px;
  font-weight: 700;
  text-align: left;
  line-height: 1.4;
  cursor: pointer;
}
.agent-conflict-link:hover {
  text-decoration: underline;
}
.agent-inline-warning {
  display: block;
  max-width: 220px;
  margin-top: 4px;
  color: #b76e00;
  font-size: 12px;
  line-height: 1.35;
}
.agent-agent-type {
  color: #344054;
  font-weight: 700;
}
.agent-row-actions {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  flex-wrap: wrap;
  gap: 5px;
}
.agent-row-actions .btn {
  font-size: 12px;
  padding: 5px 8px;
}
.agent-mobile-list {
  display: none;
}
.agent-v2-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  border: 1px solid #e7eaf0;
  border-radius: 14px;
  background: #fff;
  padding: 40px 20px;
  color: #667085;
  font-size: 13px;
}
.agent-v2-state.is-error {
  color: #c02626;
}
.agent-alert {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  border-radius: 10px;
  padding: 10px 12px;
  font-size: 12px;
  line-height: 1.6;
}
.agent-alert.is-warning {
  border: 1px solid #fde3b7;
  background: #fffaf0;
  color: #8a5a00;
}
.agent-alert.is-danger {
  border: 1px solid #f5c2c0;
  background: #fff6f5;
  color: #b42318;
}
.agent-alert-retry {
  flex: 0 0 auto;
  margin-left: auto;
  font-size: 12px;
  padding: 3px 7px;
}
.agent-confirm-backdrop {
  position: fixed;
  inset: 0;
  z-index: 2300;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(16, 24, 40, .55);
  padding: 18px;
}
.agent-confirm {
  width: 100%;
  max-width: 440px;
  overflow: hidden;
  border-radius: 14px;
  background: #fff;
  box-shadow: 0 24px 60px rgba(16, 24, 40, .28);
  outline: none;
}
.agent-confirm-head {
  padding: 17px 18px 0;
}
.agent-confirm-head h5 {
  margin: 0;
  color: #172033;
  font-size: 17px;
  font-weight: 800;
}
.agent-confirm-body {
  padding: 9px 18px 16px;
  color: #475467;
  font-size: 13px;
  line-height: 1.6;
}
.agent-confirm-body p {
  margin: 0;
}
.agent-confirm-body p + p {
  margin-top: 8px;
}
.agent-confirm-meta {
  color: #7b8ba3;
}
.agent-confirm-warning {
  color: #b76e00;
  font-size: 12px;
}
.agent-confirm-body .agent-alert {
  margin-top: 12px;
}
.agent-confirm-foot {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  border-top: 1px solid #edf1f6;
  padding: 12px 18px;
}
.agent-confirm-foot .btn {
  min-width: 104px;
  font-size: 12px;
  font-weight: 700;
}
.agent-confirm-foot .btn-danger {
  border-color: #d92d20;
  background: #d92d20;
  color: #fff;
}
.agent-confirm-foot .btn-warning {
  border-color: #f79009;
  background: #f79009;
  color: #fff;
}
.agent-confirm-foot .btn-danger:disabled,
.agent-confirm-foot .btn-warning:disabled {
  opacity: .65;
}
.agent-config-list-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 10px 0;
  border-bottom: 1px solid #f1f4f8;
}
.agent-config-list-row:last-child {
  border-bottom: 0;
}
.agent-config-list-row strong {
  display: block;
  margin-top: 4px;
  color: #344054;
  font-size: 12px;
}
.agent-config-list-row small {
  display: block;
  margin-top: 2px;
  color: #98a2b3;
  font-size: 12px;
}
.agent-config-list-actions {
  display: flex;
  align-items: center;
  gap: 6px;
  flex: 0 0 auto;
}
.agent-modal-backdrop {
  position: fixed;
  inset: 0;
  z-index: 2100;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(16, 24, 40, .45);
  padding: 18px;
}
.agent-modal {
  width: 100%;
  max-width: 760px;
  max-height: calc(100vh - 36px);
  overflow: hidden;
  border-radius: 14px;
  background: #fff;
  box-shadow: 0 24px 60px rgba(16, 24, 40, .24);
}
.agent-conflict-modal {
  display: flex;
  flex-direction: column;
}
.agent-modal-head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  border-bottom: 1px solid #edf1f6;
  padding: 16px 18px;
}
.agent-modal-kicker {
  display: block;
  color: #c02626;
  font-size: 12px;
  font-weight: 800;
  letter-spacing: .08em;
  text-transform: uppercase;
}
.agent-modal-head h5 {
  margin: 3px 0 0;
  color: #172033;
  font-size: 18px;
  font-weight: 800;
}
.agent-modal-subtitle {
  margin: 3px 0 0;
  color: #7b8ba3;
  font-size: 12px;
}
.agent-modal-close {
  border: 0;
  background: transparent;
  color: #98a2b3;
  font-size: 18px;
  line-height: 1;
  padding: 4px;
  cursor: pointer;
}
.agent-modal-body {
  min-height: 0;
  overflow-y: auto;
  padding: 16px 18px;
}
.agent-modal-foot {
  display: flex;
  justify-content: flex-end;
  border-top: 1px solid #edf1f6;
  padding: 12px 18px;
}
.agent-conflict-block {
  border: 1px solid #f3d6d6;
  border-radius: 11px;
  background: #fffafa;
  padding: 13px;
}
.agent-conflict-block + .agent-conflict-block {
  margin-top: 10px;
}
.agent-conflict-block-head h6 {
  margin: 0;
  color: #344054;
  font-size: 14px;
  font-weight: 800;
}
.agent-conflict-block-head span {
  display: block;
  margin-top: 2px;
  color: #98a2b3;
  font-size: 12px;
}
.agent-conflict-reason {
  margin: 8px 0 10px;
  color: #667085;
  font-size: 12px;
  line-height: 1.55;
}
.agent-conflict-config-list {
  border-top: 1px solid #f5e4e4;
}
.agent-conflict-config {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 9px 0;
  border-bottom: 1px solid #f5e4e4;
}
.agent-conflict-config:last-child {
  border-bottom: 0;
}
.agent-conflict-config-main {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 6px;
  min-width: 0;
}
.agent-conflict-config-main strong {
  color: #344054;
  font-size: 12px;
  overflow-wrap: anywhere;
}
.agent-conflict-config-actions {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  gap: 5px;
}
.agent-conflict-config-actions .btn {
  font-size: 12px;
  padding: 4px 7px;
}
@media (max-width: 991px) {
  .agent-filter-card {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .agent-filter-reset {
    align-self: end;
  }
  .agent-stats {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}
@media (max-width: 767px) {
  .agent-v2-heading {
    flex-direction: column;
  }
  .agent-modal-backdrop {
    padding: 8px;
  }
  .agent-modal {
    max-height: calc(100vh - 16px);
  }
  .agent-confirm-foot {
    flex-direction: column-reverse;
  }
  .agent-confirm-foot .btn {
    width: 100%;
  }
  .agent-conflict-config {
    align-items: flex-start;
    flex-direction: column;
  }
  .agent-conflict-config-actions {
    justify-content: flex-start;
  }
  .agent-v2-heading h3 {
    font-size: 22px;
  }
  .agent-table-wrap {
    display: none;
  }
  .agent-mobile-list {
    display: block;
    padding: 10px;
  }
  .agent-mobile-card {
    border: 1px solid #e7eaf0;
    border-radius: 12px;
    padding: 12px;
  }
  .agent-mobile-card + .agent-mobile-card {
    margin-top: 9px;
  }
  .agent-mobile-head {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 10px;
  }
  .agent-mobile-head strong {
    display: block;
    color: #344054;
    font-size: 13px;
  }
  .agent-mobile-head small {
    display: block;
    color: #7b8ba3;
    font-size: 12px;
  }
  .agent-mobile-meta {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 9px;
    margin-top: 10px;
    padding-top: 10px;
    border-top: 1px solid #f1f4f8;
  }
  .agent-mobile-meta span {
    display: block;
    color: #98a2b3;
    font-size: 12px;
    text-transform: uppercase;
  }
  .agent-mobile-meta strong {
    display: block;
    margin-top: 1px;
    color: #475467;
    font-size: 12px;
  }
  .agent-mobile-actions {
    display: flex;
    flex-wrap: wrap;
    gap: 6px;
    margin-top: 11px;
  }
  .agent-mobile-actions .btn {
    flex: 1 1 auto;
    font-size: 12px;
  }
}
@media (max-width: 575px) {
  .agent-filter-card {
    grid-template-columns: minmax(0, 1fr);
  }
  .agent-stats {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}
</style>



// WEBPACK FOOTER //
// src/views/ai/agentV2/list.vue